import {
  FormControl,
  InputLabel,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import { useSearchContext } from "../../../contexts/SearchContext";
import { useIndustries } from "../../../hooks/queries/useIndustries";
import { FilterSelect } from "./FilterSelect";

const FilterIndustry = () => {
  const { searchIndustry, setSearchIndustry } = useSearchContext();
  const { data: industries = [] } = useIndustries();

  const onChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value !== "0" ? event.target.value : "*";
    setSearchIndustry(value);
  };

  return (
    <FormControl size="small" variant="outlined" fullWidth>
      <InputLabel>Laboratório:</InputLabel>
      <FilterSelect
        value={searchIndustry}
        onChange={onChange}
        label="Laboratório"
      >
        <MenuItem value="*">Todos os laboratórios</MenuItem>
        {industries.map(industry => (
          <MenuItem key={industry.cd_fornecedor} value={industry.cd_fornecedor}>
            {industry.ds_fornecedor}
          </MenuItem>
        ))}
      </FilterSelect>
    </FormControl>
  );
};

export default FilterIndustry;
